import React from "react"
import loadingImg from "images/lottiefile/yellow_loading_animation.json"
import { ModalWrapper, IconWrapper, LoadingTxt } from "./style"
import LottieLoader from "components/containers/common/LottieLoader"

export default function LoadingModal({ zIndex, loadingTxt }) {
	return (
		<ModalWrapper zIndex={zIndex}>
			<IconWrapper>
				<LottieLoader
					lottieOptions={{
						loop: true,
						autoplay: true,
						renderer: "svg",
						animationData: loadingImg,
					}}
					style={{ position: "absolute", top: "0", bottom: "0", left: "0", right: "0" }}
				/>
			</IconWrapper>
			<br />
			{loadingTxt && <LoadingTxt>{loadingTxt}</LoadingTxt>}
		</ModalWrapper>
	)
}
